import { Injectable } from '@angular/core';

import { EarlyPayoutResponse } from 'packages/sports/web/app/src/my-bets-base/models/early-payout';

import { PayoutError } from '../../validation/errors/early-payout/payout-error';

export enum PayoutResultStatus {
    Success,
    Fail,
    Pending,
}

export interface IPayoutResult {
    status: PayoutResultStatus;
    actualPayout: number;
    error?: PayoutError;
}

@Injectable()
export class EarlyPayoutResponseProcessorService {
    private static readonly SUCCEEDED = 'PayoutSucceeded';
    private static readonly FAILED = 'PayoutFailed';

    constructor() {}

    processResponse(response: EarlyPayoutResponse): IPayoutResult {
        const payoutStatus = response.payoutStatus;
        if (payoutStatus.type === EarlyPayoutResponseProcessorService.FAILED) {
            return {
                status: PayoutResultStatus.Fail,
                actualPayout: 0,
                error: new PayoutError(),
            };
        }

        if (payoutStatus.type === EarlyPayoutResponseProcessorService.SUCCEEDED) {
            return {
                status: PayoutResultStatus.Success,
                actualPayout: payoutStatus.actualPayout!,
            };
        }

        return {
            status: PayoutResultStatus.Pending,
            actualPayout: 0,
        };
    }
}
